import React from 'react';
import Home from '../pages/Home/Home';
import RouteConfig from './interface';
import renderRoutes from './utils';
import EmptyPageLayout from '../Layouts/EmptyPageLayout';
import LoginPage from '../pages/LoginPage/LoginPage';
import LogoutPage from '../pages/LogoutPage/LogoutPage';
import SearchPage from '../pages/SearchPage/SearchPage';

const routes: RouteConfig[] = [
	{
		title: 'Home',
		path: '/',
		component: <Home />,
		exact: true,
		isPublic: true,
	},
	{
		title: 'About',
		path: '/about',
		component: <div>About</div>,
		exact: true,
		isPublic: true,
		layout: EmptyPageLayout,
	},
	{
		title: 'Contact',
		path: '/contact',
		component: <div>Contact</div>,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Search',
		path: '/search',
		component: <SearchPage />,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Login',
		path: '/login',
		component: <LoginPage />,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Logout',
		path: '/logout',
		component: <LogoutPage />,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Register',
		path: '/register',
		component: <div>Register</div>,
		exact: true,
		isPublic: true,
	},
	{
		title: 'Profile',
		path: '/me',
		component: <div>Profile</div>,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Settings',
		path: '/settings',
		component: <div>Settings</div>,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Visitors',
		path: '/visitors',
		component: <div>Visitors</div>,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Likes',
		path: '/likes',
		component: <div>Likes</div>,
		exact: true,
		isPublic: false,
	},
	{
		title: 'Chat',
		path: '/chat',
		component: <div>Chat</div>,
		exact: true,
		isPublic: false,
	},
];

export const Routes = renderRoutes(routes);

export default routes;
